/**
 * Holds Search state for the UI
 */
export class Search {
  /**
   * Holds the data that is bound the search field
   */
  public query: string = ''
}
